import {
  DTNode,
  DTProductSelectionNode,
  ProductSelectionNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {FeedColumn} from 'common/src/modules/relatedItems/relatedItems.types';
import {trimDescription} from 'common/src/modules/campaignVersions/utils/trimDescription';

export function serializeProductsNode(node: DTNode, newNode: ServerNode) {
  const productsNode = node as DTProductSelectionNode;

  return {
    ...newNode,
    description: trimDescription(newNode.description || ''),
    productsSelectionStrategy: productsNode.productsSelectionStrategy,
    feedId: productsNode.feedId,
    topItemLogicId: productsNode.topItemLogicId,
    retargetingProductSetId: productsNode.retargetingProductSetId,
    categoryTopItemsLogicId: productsNode.categoryTopItemsLogicId,
    productIds: productsNode.productIds,
    recommendationSources: productsNode.recommendationSources,
    ...(productsNode.configuration && {
      configuration: {
        ...productsNode.configuration,
        conditions: productsNode.configuration.conditions.map((cond) => ({
          ...cond,
          feedKey: FeedColumn[cond.feedKey as FeedColumn],
        })),
      },
    }),
    ...(productsNode.retargetingSettings && {
      retargetingSettings: productsNode.retargetingSettings,
    }),
    outputs: (node.outputs as ProductSelectionNodeOutputData[]).map((output) => {
      return {nodeId: output.nodeId, type: output.type, id: output.id};
    }),
    feedDescription: productsNode.feedDescription,
    strategyDescription: productsNode.strategyDescription,
    teamNameSourceSignalKey: productsNode.teamNameSourceSignalKey,
  };
}
